import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import { errorHandler } from '@/utils/helpers'
import { TECHNOLOGY, API_GENERAL_SETTINGS, API_SOCIODEMO_SETTINGS } from '@/utils/constants'
import { filter, get, groupBy, flatten, keys, isEmpty, isNil, remove, size, sortBy, toNumber, values, find, includes } from 'lodash'

function parseXDevice(accountData, xdeviceData) {
    return accountData.xdevice_conf_id !== '0' && get(xdeviceData, 'status', '') === 'active'
}

const actions = {
    ...commonActions,
    updateSettings({ commit, dispatch, rootState }, params) {
        return webRequestClient
            .put(`/audience_admin/accounts/${rootState.account.accountId}.json`, params.params)
            .then(response => {
                if (isEmpty(response) || get(response, 'status', '') === 'KO') {
                    errorHandler('Problems while updating your settings', commit)
                } else {
                    if (params.type === 'sociodemo') {
                        const responseLabel = API_SOCIODEMO_SETTINGS[params.settingLabel]
                        commit('setSocioDemoSetting', { type: params.settingLabel, activate: response[responseLabel] === 'YES' })
                        if (response[responseLabel] === 'YES') {
                            if (params.settingLabel === 'technology') {
                                for (const techno of TECHNOLOGY) {
                                    if (isEmpty(rootState.data[techno].list)) dispatch(`data/${techno}/retrieveItems`, {}, { root: true })
                                }
                            } else {
                                if (isEmpty(rootState.data[params.settingLabel].list)) {
                                    dispatch(`data/${params.settingLabel}/retrieveItems`, {}, { root: true })
                                }
                            }
                            commit('notifications/setAddedNotification', { type: 'success', message: params.notificationLabel + ' is enabled' }, { root: true })
                        } else if (response[responseLabel] === 'NO') {
                            commit(
                                'notifications/setAddedNotification',
                                { type: 'success', message: params.notificationLabel + ' is disabled' },
                                { root: true }
                            )
                        }
                    } else if (params.type === 'general') {
                        let _notifMessage = params.notificationLabel
                        const responseLabel = API_GENERAL_SETTINGS[params.settingLabel]

                        if (responseLabel === 'account_type') {
                            commit('setGeneralSetting', {
                                type: params.settingLabel,
                                activate: response[responseLabel] === 'thirdparty_provider'
                            })
                            commit('setGeneralSetting', {
                                type: 'bootstrapPush',
                                activate: response[responseLabel] === 'YES'
                            })
                            if (response[responseLabel] === 'thirdparty_provider') _notifMessage = _notifMessage + ' is enabled'
                            else if (response[responseLabel] === 'dmp_account') _notifMessage = _notifMessage + ' is disabled'
                        } else {
                            commit('setGeneralSetting', {
                                type: params.settingLabel,
                                activate: response[responseLabel] === 'YES'
                            })
                            if (response[responseLabel] === 'NO') _notifMessage = _notifMessage + ' is disabled'
                            else if (response[responseLabel] === 'YES') _notifMessage = _notifMessage + ' is enabled'

                            if (params.settingLabel === 'dashboardAndAlerts') {
                                commit('account/setAccountAllocationDashboardActivated', response[responseLabel], {
                                    root: true
                                })
                            }

                            if (params.settingLabel === 'frequency') {
                                // commit('data/customTaxonomies/setFrequencyOpts', response[responseLabel] === 'YES', { root: true })
                                dispatch('data/customTaxonomies/launchMultipleHierarchiesRetrieve', { list: rootState.data.customTaxonomies.list }, { root: true})
                            }
                        }
                        commit('notifications/setAddedNotification', { type: 'success', message: _notifMessage }, { root: true })
                    } else if (params.type === 'xdevice') {
                        commit('setGeneralSetting', {
                            type: 'xdevice',
                            activate: true
                        })
                        return get(response, 'xdevice_conf_id', null)
                    } else if (params.type === 'datamining') {
                        dispatch('setsAccountDataMiningSettings', { accountData: response })
                        commit('notifications/setAddedNotification', { type: 'success', message: params.notificationLabel }, { root: true })
                        if (response.datamining_activation === 'none') commit('ui/settings/setDisplayModal', { display: false }, { root: true })
                    } else if (params.type === 'wamFactory') {
                        const _key = keys(params.params)[0]
                        const isActivated = response[_key]
                        if (params.requestNamespaceCreation) {
                            dispatch('account/createNamespace', { namespace_type: 'NAV', namespace: 'NAV', pattern: '[]' }, { root: true })
                        }
                        if (_key === 'wam_factory_activated') {
                            commit('account/setAccountIsWamFactoActivated', { isActivated }, { root: true })

                            //- update ui settings for wamfactory hit logs
                            if (isActivated !== response.wamfactory_logs_activated) {
                                if (!rootState.ui.settings.wamFactory.logs) {
                                    dispatch(
                                        'ui/settings/updateStoreSetting',
                                        { name: 'logs', type: 'wamFactory', activate: isActivated === 'YES' },
                                        { root: true }
                                    )
                                }
                            }
                        } else if (_key === 'bootstrap_custom_segment_available')
                            commit('account/setAccountIsBootstrapCustomSegmentAvailable', { isActivated }, { root: true })
                        else if (_key === 'wamfactory_logs_activated') commit('account/setAccountIsWamFactoLogsActivated', { isActivated }, { root: true })
                        else if (_key === 'rule_estimation_activated ')
                            commit('account/setAccountIsEstimationFeatureAvailable', { isActivated }, { root: true })

                        let _endMessage
                        if (_key === 'wamfactory_rules_version') {
                            _endMessage = isActivated === 'V2' ? 'is enabled' : 'is disabled'
                        } else {
                            _endMessage = isActivated === 'YES' ? 'is enabled' : 'is disabled'
                        }
                        commit('notifications/setAddedNotification', { type: 'success', message: params.notificationLabel + _endMessage }, { root: true })
                    }
                }
                commit('ui/settings/setIsLoading', { isLoading: false }, { root: true })
            })
            .catch(error => {
                if (params.type === 'datamining') commit('ui/settings/setDisplayModal', { display: false }, { root: true })
                commit('ui/settings/setIsLoading', { isLoading: false }, { root: true })
                errorHandler(error, commit)
            })
    },

    // Extra Taxo
    retrieveExtraTaxos({ commit, rootState }) {
        commit('setExtraTaxoIsLoading', { isLoading: true })
        commit('ui/settings/setExtraTaxoIsLoading', { isLoading: true }, { root: true })
        return webRequestClient
            .get('/audience_admin/bigsea_taxonomies/bulk_download/json', {
                params: { account_id: rootState.account.accountId }
            })
            .then(extraTaxos => {
                if (get(extraTaxos, 'status') === 'KO' || isEmpty(extraTaxos)) {
                    errorHandler('Error while retrieving your extra taxonomies', commit)
                } else if (!isEmpty(extraTaxos.list)) {
                    const activeTaxo = size(filter(extraTaxos.list, taxo => taxo.status === 'active'))
                    commit('setTotalActiveTaxos', { activeTaxo })
                    commit('ui/settings/setTotalActiveTaxos', { activeTaxo }, { root: true })

                    const defaultTaxo = remove(extraTaxos.list, taxo => taxo.owner === 'wb' && taxo.taxonomy === 'gt')
                    const _extraTaxosGroupedByOnwer = {
                        default: defaultTaxo,
                        ...groupBy(extraTaxos.list, 'owner')
                    }
                    commit('setExtraTaxos', { items: _extraTaxosGroupedByOnwer })
                    commit('ui/settings/setExtraTaxos', { items: _extraTaxosGroupedByOnwer }, { root: true })
                } else if (isEmpty(extraTaxos.list)) {
                    commit('setTotalActiveTaxos', { activeTaxo: 0 })
                    commit('ui/settings/setTotalActiveTaxos', { activeTaxo: 0 }, { root: true })
                }
                commit('setExtraTaxoIsLoading', { isLoading: false })
                commit('ui/settings/setExtraTaxoIsLoading', { isLoading: false }, { root: true })
                return
            })
            .catch(error => {
                commit('setExtraTaxoIsLoading', { isLoading: false })
                commit('ui/settings/setExtraTaxoIsLoading', { isLoading: false }, { root: true })
                errorHandler(error, commit)
            })
    },

    requestUpdateExtraTaxo({ commit, dispatch, state, rootState, rootGetters }) {
        const currentActivateTaxoList = rootGetters['ui/settings/getAllActiveExtraTaxo']()
        const taxoList = flatten(sortBy(values(currentActivateTaxoList), 'taxonomy_order'))
        const _params = {
            taxonomies: taxoList,
            account_id: toNumber(rootState.account.accountId)
        }
        return webRequestClient
            .put('/audience_admin/bigsea_taxonomies/bulk_upload/json', _params)
            .then(updatedTaxos => {
                if (isEmpty(updatedTaxos) || get(updatedTaxos, 'status') === 'KO' || get(updatedTaxos, 'status') === 401) {
                    if (get(updatedTaxos, 'status') === 401 && !isNil(updatedTaxos.message)) {
                        errorHandler(updatedTaxos.message, commit)
                    } else {
                        errorHandler('Error while updating your extra taxonomy label', commit)
                    }
                } else {
                    commit('notifications/setAddedNotification', { type: 'success', message: 'Your extra taxonomies have been updated' }, { root: true })
                    commit('setExtraTaxos', { items: rootState.ui.settings.extraTaxo.list })
                    commit('setTotalActiveTaxos', { activeTaxo: rootState.ui.settings.extraTaxo.activeTaxo })
                    dispatch('data/behavioral/retrieveItems', {}, { root: true })
                }
            })
            .catch(error => {
                commit('ui/settings/resetExtraTaxos', { previousExtraTaxos: state.extraTaxo }, { root: true })
                errorHandler(error, commit)
            })
    },

    updateTaxoLabel({ commit, dispatch }, params) {
        if (!isNil(params.newLabel)) {
            if (params.currentStatus !== 'active') {
                dispatch('updateExtraTaxoAction', { taxoToUpdate: params.taxo, status: 'active' })
            }
            commit('ui/settings/setExtraTaxoNewLabel', { taxo: params.taxo, currentLabel: params.taxo.label, newLabel: params.newLabel }, { root: true })
        }
    },

    updateExtraTaxoAction({ commit }, params) {
        commit('ui/settings/updateExtraTaxo', { taxoToUpdate: params.taxoToUpdate, status: params.status }, { root: true })
        commit('ui/settings/updateExtraTaxoCounter', { status: params.status }, { root: true })
    },

    //XDevice actions
    createXDeviceConf({ commit, dispatch, rootState }, params) {
        return webRequestClient
            .post('/audience_admin/xdevice_confs.json', { ...params, account_id: toNumber(rootState.account.accountId) })
            .then(xdevice => {
                if (isEmpty(xdevice) || get(xdevice, 'status') === 'KO' || get(xdevice, 'status') === 401) {
                    if (get(xdevice, 'status') === 401 && !isNil(xdevice.message)) {
                        errorHandler(xdevice.message, commit)
                    } else {
                        errorHandler('Error while creating xdevice infos', commit)
                    }
                } else {
                    dispatch('updateSettings', {
                        params: { xdevice_conf_id: xdevice.id },
                        type: 'xdevice',
                        notificationLabel: 'Xdevice'
                    }).then(xdeviceId => {
                        if (xdeviceId === xdevice.id) {
                            commit('account/setAccountXDeviceInfo', { xDeviceInfo: { ...xdevice, status: 'active' } }, { root: true })
                            commit('notifications/setAddedNotification', { type: 'success', message: 'Xdevice is account enabled' }, { root: true })
                        }
                    })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },
    updateXDeviceConf({ commit, rootState }, params) {
        return webRequestClient
            .put(`/audience_admin/xdevice_confs/${params.params.id}.json`, { ...params.params, account_id: toNumber(rootState.account.accountId) })
            .then(xdevice => {
                if (isEmpty(xdevice) || get(xdevice, 'status') === 'KO' || get(xdevice, 'status') === 401) {
                    if (get(xdevice, 'status') === 401 && !isNil(xdevice.message)) {
                        errorHandler(xdevice.message, commit)
                    } else {
                        errorHandler('Error while updating xdevice infos', commit)
                    }
                } else {
                    commit('account/setAccountXDeviceInfo', { xDeviceInfo: xdevice }, { root: true })
                    commit('setGeneralSetting', { type: 'xdevice', activate: xdevice.status === 'active' })
                    commit('notifications/setAddedNotification', { type: 'success', message: params.notifMessage }, { root: true })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },
    updateXDevice({ commit, dispatch, rootState }, params) {
        if (params.scope === 'pool') {
            //new scope === 'pool', xdevice already exists,  update conf with new scope or status
            dispatch('updateXDeviceConf', {
                params: {
                    id: rootState.account.xDeviceInfo.id,
                    label: rootState.account.label,
                    scope: 'pool',
                    provider: rootState.account.xDeviceInfo.provider,
                    status: params.activate ? 'active' : 'inactive'
                },
                notifMessage: params.activate ? 'Xdevice is pool enabled' : 'Xdevice is disabled'
            })
        } else if (params.scope === 'account') {
            //new scope === 'account', may not be created yet:
            // first, check if xdevice conf id is in store (xdevice conf exists)
            // if does not exist, create one, otherwise, update status or scope
            if (params.activate && isNil(get(rootState, 'account.xDeviceInfo.id', null))) {
                //create new xdevice conf
                const provider = rootState.account.accountId + ' ' + rootState.account.label
                dispatch('createXDeviceConf', {
                    label: rootState.account.label,
                    scope: provider,
                    provider
                })
            } else if (!isNil(get(rootState, 'account.xDeviceInfo.id', null))) {
                dispatch('updateXDeviceConf', {
                    params: {
                        id: rootState.account.xDeviceInfo.id,
                        label: rootState.account.label,
                        scope: rootState.account.xDeviceInfo.provider,
                        provider: rootState.account.xDeviceInfo.provider,
                        status: params.activate ? 'active' : 'inactive'
                    },
                    notifMessage: params.activate ? 'Xdevice is account enabled' : 'Xdevice is disabled'
                })
            }
        }
        if (params.activate) {
            commit('data/audience/setEmptyVolumes', {}, { root: true })
        }
        commit('ui/settings/setIsLoading', { isLoading: false }, { root: true })
    },
    checkDataMiningKey({ commit }, params) {
        return webRequestClient
            .get('/audience_admin/accounts/check_datamining_key/json', {
                params: { key: params.key }
            })
            .then(response => {
                if (get(response, 'key', null) === 'valid') return true
                errorHandler('Error while checking your SSH key', commit)
            })
            .catch(error => {
                if (get(error, 'apiError.status', null) === 400) return false
                errorHandler(error, commit)
            })
    },

    // Sharing
    retrieveLinkedAccounts({ commit, dispatch, rootState, rootGetters }) {
        const _params = {
            params: {
                account_id: toNumber(rootState.account.accountId)
            }
        }
        return webRequestClient
            .get('/audience_admin/sharings/linked_accounts.json', _params)
            .then(response => {
                if (isEmpty(response) || get(response, 'status', '') === 'KO') {
                    errorHandler('Problems while retrieveing your sharings', commit)
                } else {
                    commit('setSharingTaxo', { linkedAccounts: response.list })
                    const alreadyActiveSharing = rootGetters['ui/settings/getActiveSharing']({ sharingType: 'taxonomies' })
                    commit('ui/settings/setDefaultActiveSharing', { alreadyActiveSharing: alreadyActiveSharing }, { root: true })
                    commit('data/settings/setDefaultActiveSharing', { alreadyActiveSharing: alreadyActiveSharing }, { root: true })
                    return dispatch('data/settings/getWaxSharing', {}, { root: true })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },
    getWaxSharing({ commit, rootState }) {
        const _params = {
            params: {
                account_id: toNumber(rootState.account.accountId)
            }
        }
        return webRequestClient
            .get('/audience_admin/wax_sharings/get_wax_sharings.json', _params)
            .then(response => {
                if (isEmpty(response) || get(response, 'status', '') === 'KO') {
                    errorHandler('Problems while retrieveing your sharings', commit)
                } else {
                    const audienceSharing = []
                    const activeAudienceSharing = []

                    for (const item of response.list) {
                        activeAudienceSharing.push(toNumber(item.id))
                    }

                    for (const audience of rootState.data.settings.sharing.taxonomies) {
                        if (includes(activeAudienceSharing, toNumber(audience.id))) audience.audience_sharing = 'active'
                        else audience.audience_sharing = 'inactive'
                        audienceSharing.push(audience)
                    }
                    commit('setSharingAudiences', { linkedAccounts: audienceSharing })
                    commit('ui/settings/setSharingType', { sharingType: 'audiences' }, { root: true })
                    commit('ui/settings/setDefaultActiveSharing', { alreadyActiveSharing: activeAudienceSharing }, { root: true })
                    commit('ui/settings/resetSharings', {}, { root: true })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },
    requestActivateSharing({ commit, rootState }, params) {
        let requestUrl
        const _params = {
            account_id: toNumber(rootState.account.accountId),
            linked_account_ids: params.linked_account_ids
        }

        if (rootState.ui.settings.sharing.sharingType === 'taxonomies') {
            _params.sharing_type = params.sharing_type
            requestUrl = '/audience_admin/sharings/linked_accounts.json'
        } else if (rootState.ui.settings.sharing.sharingType === 'audiences') {
            requestUrl = '/audience_admin/wax_sharings/update_wax_sharings.json'
        }
        return webRequestClient
            .put(requestUrl, _params)
            .then(response => {
                if (isEmpty(response) || get(response, 'status', '') === 'KO') {
                    errorHandler('Problems while updating your sharings', commit)
                } else {
                    commit(
                        'data/settings/updateSharings',
                        {
                            sharingType: rootState.ui.settings.sharing.sharingType,
                            addedSharings: rootState.ui.settings.sharing.sharingToAdd,
                            deletedSharings: rootState.ui.settings.sharing.sharingToRemove
                        },
                        { root: true }
                    )
                    commit('notifications/setAddedNotification', { type: 'success', message: 'Sharing status updated' }, { root: true })
                    commit('ui/settings/resetSharings', {}, { root: true })
                    commit('data/settings/setDefaultActiveSharing', { alreadyActiveSharing: rootState.ui.settings.sharing.activeSharing }, { root: true })
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },

    // store updates
    setsAccountGeneralSettings({ commit }, params) {
        commit('setGeneralSetting', { type: 'accuracy', activate: params.accountData.throttle_level === 'YES' })
        commit('setGeneralSetting', { type: 'catalog', activate: params.accountData.account_type === 'thirdparty_provider' })
        commit('setGeneralSetting', { type: 'demographicBreakdown', activate: params.accountData.demographic_breakdown_activated === 'YES' })
        commit('setGeneralSetting', { type: 'frequency', activate: params.accountData.frequency_activated === 'YES' })
        commit('setGeneralSetting', { type: 'quantile', activate: params.accountData.quantile_activated === 'YES' })
        commit('setGeneralSetting', { type: 'surfintensity', activate: params.accountData.surf_intensity_activated === 'YES' })
        commit('setGeneralSetting', { type: 'bootstrapPush', activate: params.accountData.stock_delivery_activated === 'YES' })
        commit('setGeneralSetting', { type: 'firstPartyCookie', activate: params.accountData.first_party_cookie_volume_activated === 'YES' })
        commit('setGeneralSetting', { type: 'providerFirstIdActivated', activate: params.accountData.provider_firstid_activated === 'YES' })
        commit('setGeneralSetting', { type: 'providerUtiqActivated', activate: params.accountData.provider_utiq_activated === 'YES' })
        if (!isEmpty(get(params, 'xdeviceData', {}))) {
            commit('setGeneralSetting', { type: 'xdevice', activate: parseXDevice(params.accountData, params.xdeviceData) })
        }
    },
    setsAccountSocioDemoSettings({ commit }, params) {
        commit('setSocioDemoSetting', { type: 'behavioral', activate: params.accountData.bigsea_behavioral === 'YES' })
        commit('setSocioDemoSetting', { type: 'demographic', activate: params.accountData.bigsea_sociodemo === 'YES' })
        commit('setSocioDemoSetting', { type: 'geography', activate: params.accountData.geographic_activated === 'YES' })
        commit('setSocioDemoSetting', { type: 'technology', activate: params.accountData.technologic_activated === 'YES' })
    },
    setsAccountDataMiningSettings({ commit }, params) {
        commit('setDataMiningSetting', { type: 'datamining', activate: params.accountData.datamining_activation !== 'none' })
        commit('setDataMiningSetting', {
            type: 'encryption',
            activate: params.accountData.ssh_public_key === '' ? true : params.accountData.datamining_encryption === 'YES'
        })
        commit('setDataMiningSetting', { type: 'fullmode', activate: params.accountData.datamining_fullmode === 'YES' })
        commit('setDataMiningSetting', { type: 'secondparty', activate: params.accountData.datamining_2ndparty_activated === 'YES' })
        commit('setDataMiningSetting', { type: 'thirdparty', activate: params.accountData.datamining_3rdparty_activated === 'YES' })
        commit('setDataMiningSetting', { type: 'altid', activate: params.accountData.datamining_altids_activated === 'YES' })
        commit('setDataMiningSetting', { type: 'sshKey', activate: params.accountData.ssh_public_key })
    },

    //Business Apps

    /**
     * Retrieves the list of all business apps
     * @returns {Promise}
     */
    retrieveBusinessApps({ commit }) {
        return webRequestClient
            .get('/audience_admin/business_apps.json', { params: { list_limit: 0 } })
            .then(response => {
                commit('setBusinessAppsList', { list: response.list })
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },

    /**
     * Retrieves the list of all business apps for a product account ID
     * @returns {Promise}
     */
    retrieveBusinessAppsProductAccount({ commit, rootState }) {
        return webRequestClient
            .get(`/audience_admin/business_apps/product_accounts/${rootState.account.accountId}/business_apps.json`)
            .then(response => {
                commit('setProductAccountBusinessAppsList', { list: response.list })
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },

    /**
     * Enables the link between an account and a business App
     * @param {Object} payload
     * @param {Array} payload.businessAppId - Id of the item that will need to be updated
     * @returns {Promise}
     */
    linkBusinessAppWithAnAccount({ commit, state, rootState }, params) {
        const _params = {
            product_account_id: rootState.account.accountId,
            business_app_id: params.businessAppId,
            application_id: 0
        }
        return webRequestClient
            .post('/audience_admin/business_apps/business_apps_product_accounts.json', _params)
            .then(response => {
                const element = find(state.businessApps.list, item => item.id === response.business_app_id)
                commit('updateProductAccountBusinessAppStatusLink', { element: element })
                commit('notifications/setAddedNotification', { type: 'success', message: ` Business App ${element.label} is now enabled` }, { root: true })
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    },

    /**
     * Disables the link between an account and a business App
     * @param {Object} payload
     * @param {Array} payload.businessAppId - Id of the item that will need to be updated
     * @returns {Promise}
     */
    unlinkBusinessAppWithAnAccount({ commit, state, rootState }, params) {
        const _params = {
            product_account_id: rootState.account.accountId,
            business_app_id: params.businessAppId
        }
        return webRequestClient
            .put('/audience_admin/business_apps/product_accounts/business_app_delete/.json', _params)
            .then(() => {
                const element = find(state.businessApps.list, item => toNumber(item.id) === toNumber(params.businessAppId))
                commit('updateProductAccountBusinessAppStatusUnlink', { id: params.businessAppId })
                commit('notifications/setAddedNotification', { type: 'success', message: ` Business App ${element.label} is now disabled` }, { root: true })
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    }
}

export default actions
